import React from 'react';
import './MiddlePanel.css';

const MiddlePanel = ({
    children,
    isVisible,
    zIndex,
    overlay
}) => {
    return (
        <>
            {overlay && isVisible && <div className="overlay"></div>}
            <div className={`middle-panel${isVisible ? '' : ' not-show'}`} style={{ zIndex: zIndex }}>
                {children}
            </div>
        </>
    );
}

export default MiddlePanel;
